import { appEvents } from "@cayo/shared/components/App/appEvents";
import { IPropertiesPanel } from "@cayo/shared/components/AppRoots/PropertiesPanelHolder/types";
import { bindingsUtils } from "@cayo/shared/scheme/bindings";
import { IActionHandlerParams } from "../types";

export const showPicker = (actionId: string, parameters?: IActionHandlerParams) => {
  const actualId = parameters?.objects
    ? (bindingsUtils.resolveExpression(parameters.objects[0] as any, actionId) as string)
    : actionId;

  appEvents.trigger({
    showControl: {
      controlId: "scheme",
      parameters: {
        id: actualId || actionId,
        ...parameters, // TEMPORARY
        parentId: parameters?.parentId,
        isPicker: true,
        object: undefined,
      } as IPropertiesPanel,
    },
  });
};
